import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';

import { getLayoutProps } from '@/utils/layout/layout';
import PageLayout from '@/components/PageLayout';
import User from '@/store/user';
import CardsSection from '@/components/CardsSection/CardsSection';

export default function UserCards({ responsiveLogo, image }) {
  const [user, setUser] = useState();
  const router = useRouter();
  useEffect(() => {
    const user$ = User.subscribe(_user => {
      if (isEmpty(_user)) {
        router.replace('/login');
        return;
      }
      setUser(_user);
    });
    return () => user$.unsubscribe();
  }, []);

  if (!user?._id) return null;

  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>
      <CardsSection user={user} image={image} />
    </>
  );
}

UserCards.getLayout = function getLayout(page) {
  return (
    <PageLayout isUserLayout userSelectedMenu={'cards'}>
      {page}
    </PageLayout>
  );
};

export async function getStaticProps({ locale }) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: 0 } }, locale);
  const image = layoutProps?.emptyStates?.cards_empty_state?.url
    ? layoutProps?.emptyStates?.cards_empty_state?.url
    : null;
  const messages = {
    common: (await import(`../../../../prebuild-data/i18n/${locale}/common.json`)).default,
    user_cards: (await import(`../../../../prebuild-data/i18n/${locale}/user_cards.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      messages,
      image,
    },
  };
}
